import React, { useEffect, useState } from "react";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";

function Catagorylist() {
  const [catagorylist, setcatagorylist] = useState([]);
  const token = sessionStorage.getItem("token");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Base URL for constructing image paths
  const baseUrl = process.env.REACT_APP_APIURL;

  const filteredData = catagorylist.filter((item) =>
    Object.values(item).some(
      (val) =>
        val &&
        typeof val === "string" &&
        val.toLowerCase().includes(search.toLowerCase())
    )
  );

  const offset = currentPage * itemsPerPage;
  const paginatedData =
    itemsPerPage === -1
      ? filteredData
      : filteredData.slice(offset, offset + itemsPerPage);
  const pageCount =
    itemsPerPage === -1 ? 1 : Math.ceil(filteredData.length / itemsPerPage);

  const fetchCategoryList = async () => {
    if (!token) {
      toast.error("No token provided!");
      return;
    }

    try {
      const response = await axios.get(
        `${baseUrl}api/catagorylist`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Sort data by creation date to show newest first
      const sortedCategories = (response.data?.catagories || []).sort(
        (a, b) => new Date(b.CreatedAt) - new Date(a.CreatedAt)
      );
      setcatagorylist(sortedCategories);
    } catch (error) {
      toast.error(
        "Error fetching data: " +
        (error.response?.data?.message || error.message)
      );
    }
  };

  const handleDeleteCategory = async (id) => {
    // Add confirmation before deleting
    if (!window.confirm("Are you sure you want to delete this category?")) {
      return;
    }

    if (!token) {
      toast.error("No token provided!");
      return;
    }
    try {
      const response = await fetch(
        `${baseUrl}api/deletecatagory/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        toast.success("Category deleted successfully!");
        fetchCategoryList(); // Refresh the list after deletion
      } else {
        const data = await response.json();
        toast.error(data.message || "Failed to delete category");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    }
  };

  useEffect(() => {
    fetchCategoryList();
  }, []);

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Catagory List</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={"/"}>Home</Link>
              </li>
              <li className="breadcrumb-item active">Catagory List</li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  {/* Search and Entries Per Page */}
                  <div className="datatable-top d-flex justify-content-between align-items-center pt-4">
                    <div className="datatable-dropdown">
                      <label className="me-2">
                        Show{" "}
                        <select
                          className="datatable-selector"
                          value={itemsPerPage}
                          onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(0); // Reset to first page
                          }}
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="-1">All</option>
                        </select>{" "}
                        entries
                      </label>
                    </div>
                    <div className="datatable-search">
                      <input
                        className="form-control"
                        placeholder="Search..."
                        type="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Table */}
                  <div className="datatable-container table-responsive">
                    <table className="table datatable table-bordered table-striped">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Image</th>
                          <th scope="col">Catagory Name</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.length > 0 ? (
                          paginatedData.map((item, index) => (
                            <tr key={item._id}>
                              <td>{offset + index + 1}</td>
                              <td>
                                <img
                                  src={
                                    item.image
                                      ? `${item.image}`
                                      : "https://placehold.co/50x50/EFEFEF/AAAAAA?text=No+Image"
                                  }
                                  alt={item.catagoryname}
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                  }}
                                  onError={(e) => {
                                    // Handle broken image links
                                    e.target.onerror = null;
                                    e.target.src =
                                      "https://placehold.co/50x50/EFEFEF/AAAAAA?text=Error";
                                  }}
                                />
                              </td>
                              <td>{item.catagoryname}</td>
                              <td>
                                <div className="d-flex gap-3">
                                  <Link to={`/updatecatagory/${item._id}`} title="Edit">
                                    <i className="bi bi-pencil-square text-primary"></i>
                                  </Link>
                                  <Link
                                    to="#"
                                    title="Delete"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleDeleteCategory(item._id);
                                    }}
                                  >
                                    <i className="bi bi-trash text-danger"></i>
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center">
                              No matching records found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className="datatable-bottom d-flex justify-content-between align-items-center">
                    <span className="datatable-info">
                      Showing {offset + 1} to {offset + paginatedData.length} of{" "}
                      {filteredData.length} entries
                    </span>

                    <ReactPaginate
                      previousLabel={"‹"}
                      nextLabel={"›"}
                      breakLabel={"..."}
                      pageCount={pageCount}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={(e) => setCurrentPage(e.selected)}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      forcePage={currentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Catagorylist;
